import { jwtDecode } from 'jwt-decode';
import { Token } from 'src/features/auth/types';
import { storage } from 'src/utils/storage';

export const getCurrentUserId = (): string => {
    const { access } = storage.getToken();
    if (!access) return '';
    try {
        return jwtDecode<Token>(access).sub ?? '';
    } catch {
        return '';
    }
};
